import { ChartDesignerConditionallityActionTypes } from './constants';
import { renameDuplicate } from '../../utils/renameDuplicate';

interface State {    
    conditionallity: any,
}

const INIT_STATE = {    
    conditionallity: [],        
};

const ChartDesignConditonallity = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {        
        case ChartDesignerConditionallityActionTypes.CHANGE_GET_CONDITIONALLITYLIST:
            return {
                ...state,
                conditionallity: action.payload.shaxesList.map((b: any) => (
                    {
                        id: b.id,
                        name: b.UniqueName,
                        type:b.type,
                        condition: {
                            type: b?.conditionallity?.type ? b?.conditionallity?.type : '',
                            detail: b?.conditionallity?.detail ? b?.conditionallity?.detail : {}
                        }
                    }
                )),
            };

        case ChartDesignerConditionallityActionTypes.CHANGE_CONDITIONALLITY:
            const s_conditionallityIndex = state.conditionallity.findIndex((object: any) => { return object.id === action.payload.id })
            const s_conditionallity = state.conditionallity;
            if (s_conditionallityIndex !== -1) {                
                if (action.payload.type !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.type = action.payload.type

                if (action.payload.scale !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.detail.scale = action.payload.scale

                if (action.payload.upperColor !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.detail.upperColor = action.payload.upperColor

                if (action.payload.lowerColor !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.detail.lowerColor = action.payload.lowerColor

                if (action.payload.centerColor !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.detail.centerColor = action.payload.centerColor

                if (action.payload.upperValue !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.detail.upperValue = action.payload.upperValue

                if (action.payload.lowerValue !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.detail.lowerValue = action.payload.lowerValue

                if (action.payload.centerValue !== undefined)
                s_conditionallity[s_conditionallityIndex].condition.detail.centerValue = action.payload.centerValue
            }

            return {
                ...state,
                conditionallity: s_conditionallity
            };




        default:
            return state;
    }
};

export default ChartDesignConditonallity;
